import styled from "styled-components";

const Container = styled.div`
	margin-top: 40px;
`;

export { Container };
